import { createSelector } from 'reselect';
import { updateFastShippingCopyMeganavLGSelector } from 'selectors/testTarget/offers/updateFastShippingCopyMeganavLG/updateFastShippingCopyMeganavLGSelector';

const activeSelector = createSelector(
    updateFastShippingCopyMeganavLGSelector,
    updateFastShippingCopyMeganavLG => !!updateFastShippingCopyMeganavLG.active
);

export { activeSelector };
